import { FC } from "react";
import { PromotionBannerProps } from "./PromotionBannerTypes";
import { Text } from "@otrium/atoms";
import {
  StyledBannerFakeButton,
  StyledBannerTypeTwoHeading,
  StyledBannerTypeTwoHeadingWrapper,
  StyledBannerTypeTwoImg,
  StyledBannerTypeTwoWrapper,
} from "src/molecules/PromotionBanner/PromotionBanner.styled";

interface PromotionBannerTypeTwoProps extends PromotionBannerProps {
  backgroundColor: string;
}

const PromotionBannerTypeTwo: FC<PromotionBannerTypeTwoProps> = ({
  bannerImageSrc,
  title,
  description,
  buttonTitle,
  buttonColor,
  buttonTextColor,
  conditionText,
  backgroundColor,
  hideCTAButton,
  titleColor,
  textColor,
}) => {
  return (
    <StyledBannerTypeTwoWrapper
      flexDirection={["column-reverse", "row", "row", "row"]}
    >
      <StyledBannerTypeTwoHeadingWrapper backgroundColor={backgroundColor}>
        <StyledBannerTypeTwoHeading
          as="h1"
          color={titleColor || "tone.white"}
          pb={0}
          fontSize={[4, 4, 4, 5]}
          lineHeight={["40px", "40px", "40px", "64px"]}
          fontWeight="700"
        >
          {title}
        </StyledBannerTypeTwoHeading>
        {description && (
          <Text
            as="p"
            fontSize={["fontSize18", "fontSize18", "22px"]}
            lineHeight={["24px", "24px", "32px"]}
            textAlign="center"
            color={textColor || "tone.white"}
            mb="space16"
          >
            {description}
          </Text>
        )}
        {!hideCTAButton ? (
          <StyledBannerFakeButton
            textColor={buttonTextColor || "tone.white"}
            buttonColor={buttonColor}
          >
            {buttonTitle}
          </StyledBannerFakeButton>
        ) : null}
        {conditionText && (
          <Text
            fontSize="fontSize12"
            color={textColor || "tone.white"}
            textAlign="center"
          >
            {conditionText}
          </Text>
        )}
      </StyledBannerTypeTwoHeadingWrapper>
      <StyledBannerTypeTwoImg src={bannerImageSrc} />
    </StyledBannerTypeTwoWrapper>
  );
};

export default PromotionBannerTypeTwo;
